<template>
  <div class="login">
    <el-dialog
        title="登录"
        :visible.sync="show"
        :before-close="close"
        :close-on-click-modal="false"
        center>
      <!-- 登录模式切换 -->
      <el-tabs v-model="activeName">
        <el-tab-pane label="密码登录" name="1">
          <el-form :model="params" ref="psd_form">
            <el-form-item
                prop="message"
                :rules="{ required: true, message: '请输入用户名/手机号/邮箱', trigger: 'blur' }"
            >
              <el-input @keyup.enter.native="submit('psd_form')" class="user_name" v-model="params.message" placeholder="请输入用户名/手机号/邮箱"></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              :rules="{ required: true, message: '请输入密码', trigger: 'blur' }"
            >
              <el-input @keyup.enter.native="submit('psd_form')" type="password" show-password class="password" v-model="params.password" placeholder="请输入密码"></el-input>
            </el-form-item>

            <el-button type="primary" class="login_btn" @click="submit('psd_form')">登录</el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="验证码登录" name="2">
          <el-form :model="params2"  ref="code_form">
            <el-form-item
                prop="mobile"
                :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' },
                                         {pattern: /^1[0-9]{10,10}$/, message: '手机号格式错误'}]"
            >
              <el-input @keyup.enter.native="submit('psd_form')" class="user_name" v-model="params2.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item
                prop="mobileCode"
                :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }"
            >
              <div>
                <el-input @keyup.enter.native="submit('psd_form')" class="code" v-model="params2.mobileCode" placeholder="请输入验证码"></el-input>
                <el-button class="get_code" @click="getCode" v-if="downcount">获取验证码</el-button>
                <el-button class="get_code" v-else disabled>验证码({{times}}s)</el-button>
              </div>
            </el-form-item>

            <el-button type="primary" class="login_btn" @click="submit('code_form')">登录</el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <!-- 文字按钮 -->
      <div class="text_btn">
        <el-button type="text" @click="forgetPassword">忘记密码？</el-button>
        <el-button type="text" @click="register">账号注册</el-button>
      </div>
      <!-- 第三方登录 -->
      <div class="other_login">
        <div class="qq_login">
          <img src="@/assets/img/login/qq.png" alt="">
        </div>
        <div class="wx_login">
          <img src="@/assets/img/login/wechat.png" alt="">
        </div>
      </div>
    </el-dialog>
    <!-- 验证码对话框 -->
    <yzmAlert :yzmObj="yzmObj" @setDwoncountSwitch="downcoutStart"></yzmAlert>
  </div>
</template>

<script>
  import yzmAlert from "@/components/yzm_alert/yzm_alert.vue"
  export default {
    components:{
      yzmAlert
    },
    props:{
      show: false
    },
    data(){
      return{
        activeName: '1',
        params:{
          message: '',
          password: ''
        },
        params2:{
          mobile: '',
          mobileCode: ''
        },
        yzmObj:{
          dialogVisible: false,
          mobile: '',
          type: 'MobileCodeTypeUserLogin'
        },

        downcount: true, //倒计时切换开关
        times: 60, //倒计时时间
        timer: null, //定时器
      }
    },
    created(){

    },
    methods:{
      /** 点击打开注册对话框*/
      register(){
        this.close();
        this.$store.dispatch('setIsRegisterDialog', true)
      },
      forgetPassword(){
        this.close();
        this.$store.dispatch('setIsForgetPasswordVisible', true)
      },
      // 发送验证码切换倒计时
      downcoutStart(data) {
        if (data) {
          this.downcount = false;
          clearInterval(this.timer);
          this.times = 60;
          this.timer = setInterval(() => {
            this.times--;
            if (this.times === 0) {
              clearInterval(this.timer);
              this.timer = false;
              this.downcount = true;
            }
          }, 1000);
        }
      },
      /** 点击获取验证码*/
      getCode(){
        if (this.downcount) {
          if (!this.params2.mobile || !/^1[0-9]{10,10}$/.test(this.params2.mobile)) {
            this.$message.info('手机号格式有误');
            return;
          }
          this.yzmObj.mobile = this.params2.mobile;
          this.yzmObj.dialogVisible = true;
        }else{
          this.$message.info("请不要重复点击");
        }
      },
      /** 验证表单*/
      submit(form){
        this.$refs[form].validate(valid => {
          if (valid) {
            form==='code_form' ?
            this.loginCode() : this.login();
          } else {
            this.$message.info("请检测必填项!");
            return false;
          }
        });
      },
      /** 登录*/
      async login(){
        let password = await this.common.pswMD5(this.params.password);
        let params = Object.assign({}, this.params, password);
        this.api.loginByPassword(params).then(res=>{
          if(res.error['err_code'] === 0) {
            this.$store.dispatch('setIsRouterAlive', false);
            sessionStorage.setItem('login','1');
            this.regPassword(()=>{
              this.close();
            })
          }
          //密码过期
          if(res.error['err_code'] === 101){
            let html = `<div>您好，您的登录密码已过期，为保障个人信息数据安全，请前往修改密码，谢谢！</div>`
            this.$alert(html, '提示', {
              dangerouslyUseHTMLString: true,
              callback: action => {
                if(action === 'cancel') return;
                this.forgetPassword();
              }
            });
          }
        })
      },
      //验证密码
      regPassword(fn){
        let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,}$/;
        if(!reg.test(this.params.password)){
          //退出登录
          this.exitLogin();
          let html = `<div>为更好保障您的信息安全，平台已对密码规则进行升级，请前往修改</div>`
          this.$alert(html, '提示', {
            dangerouslyUseHTMLString: true,
            callback: action => {
              if(action === 'cancel') return;
              this.forgetPassword();
            }
          });
        }else{
          fn && fn()
        }
      },
      //退出登录
      exitLogin(){
        this.api.exitLogin({}, true).then(res=>{
          if(res.error['err_code'] !== 0) return;
          sessionStorage.clear();
          this.$store.dispatch('setInfo', null)
        })
      },
      /** 验证码登录*/
      loginCode(){
        this.api.loginByMobileCode(this.params2).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.$store.dispatch('setIsRouterAlive', false);
          sessionStorage.setItem('login','1');
          this.close();
        })
      },
      close(){
        Object.assign(this.$data, this.$options.data())
        this.$store.dispatch('setIsLoginDialog', false)
      }
    }
  }
</script>

<style lang="scss">
.login{
  //对话框样式
  .el-dialog{
    width: 400px;overflow: hidden;
  }
  .el-dialog__header{
    padding: 0;
    height: 60px;
    background-color: #F5F6FA;
    .el-dialog__title{
      line-height: 60px;
      font-size: 20px;
      color: $font-black;
    }
  }
  .el-dialog__body{
    box-sizing: border-box;
    padding: 20px 50px 30px 50px;
  }

  //tab切换
  .el-tabs .el-tabs__header{
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__nav-wrap:after{
      display: none;
    }
    .el-tabs__nav-scroll .el-tabs__nav{
      width: 100%;
      display: flex;
      justify-content: space-evenly;
    }
    .el-tabs__item{
      color: $font-gary;
      font-size: 14px;
    }
    .el-tabs__item.is-active{
      color: $font-black;
    }
  }

  //表单
  .el-form{
    .user_name,.password{
      width: 300px;
      height: 36px;
    }
    .code{
      width: 194px;
      height: 36px;
      margin-right: 10px;
    }
    .get_code{
      width: 96px;
    }
    .login_btn{
      width: 300px;
      height: 40px;
    }
  }

  //文字按钮
  .text_btn{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .el-button:first-child{
      color: #999;
    }
    .el-button{
      color: $font-blue;
    }
  }

  //第三方登录
  .other_login{
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
    div{
      width: 40px;
      height: 40px;
      cursor: pointer;
      img{
        width: 100%;
      }
    }
  }
}
</style>
